<template>
<div>
   <b-form-checkbox-group :options="tableFilterBoxes" v-model="mailResultsFilter">
                
              </b-form-checkbox-group>
              <b-table striped :items="items" :fields="emails_fields" :tbody-tr-class="rowClass" :filter="mailResultsFilter" :filter-function="filterTable">
                <template v-slot:cell(state)="data">
                  {{ states.translate(data.value, 'emails') }}
                </template>
                <template v-slot:cell(family)="data">
                  {{ data.value.data.surname}}
                </template>
              </b-table>
</div>
</template>

<script>
import States from '@/components/Lists.js'
export default {
  name: 'Operation',
  props: ['items'],
  data() {
    return { 
        states: States,     
        mailResultsFilter: [2, -1],
        tableFilterBoxes: [{
            text: 'Sucesso',
            value: 2
        }, {
            text: 'Erro',
            value: -1
        }],
        emails_fields: [{
            key: 'family_id',
            text: 'ID Família'
        }, {
            key: 'family',
            text: 'Família'
            }, {
            key: 'subject',
            text: 'Assunto'
        }, {
            key: 'state',
            text: 'Estado'
        }, {
            key: 'updated_at',
            value: 'Última atualização'
        }]

    }
  },
  methods: {    
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.state === 2) return 'table-success'
      if (item.state < 0) return 'table-danger'
    },
    filterTable(row, filter) {
        console.log(filter)
        
      if (filter.indexOf(row.state) >= 0 ) {
        return true;
      } else {
        return false;
      }
    }
  }
}
</script>
